(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flat-river-hat-customizer"] && !Shopify.designMode) return;
  try {
    function initializeFlatRiverOrder(root) {
 if(root.dataset.frInitialized)return;root.dataset.frInitialized='true';
 const form=root.closest('form'); if(!form)return;
 const select=root.querySelector('[data-color-select]');
 const cards=[...root.querySelectorAll('.fr-color-card')];
 const preview=root.querySelector('.fr-color-preview');
 function update(){const card=cards.find(c=>c.dataset.color===select.value);cards.forEach(c=>c.setAttribute('aria-pressed',String(c===card)));if(card){root.querySelector('input[name="properties[Hat style]"]').value=card.dataset.model||'Richardson 112';root.querySelector('input[name="properties[Hat size]"]').value=card.dataset.model==='Richardson 112P'?'Adjustable':'M/L adjustable';preview.hidden=false;preview.querySelector('img').src=card.dataset.photo;preview.querySelector('img').alt=card.dataset.color;preview.querySelector('p').textContent=card.dataset.color;}}
 cards.forEach(card=>card.addEventListener('click',()=>{select.value=card.dataset.color;update();}));
 select?.addEventListener('change',update);
 root.querySelector('[data-color-search]')?.addEventListener('input',event=>{const q=event.target.value.toLowerCase().trim();cards.forEach(c=>c.hidden=!c.dataset.color.toLowerCase().includes(q));root.querySelector('[data-no-colors]').hidden=cards.some(c=>!c.hidden);});
 const fields=root.querySelector('[data-fr-custom-fields]'),shown=root.querySelector('[data-fr-shown-properties]');
 const modeInputs=[...root.querySelectorAll('[data-fr-mode]')];
 function setMode(){const isShown=root.querySelector('[data-fr-mode="shown"]')?.checked===true;fields.disabled=isShown;fields.hidden=isShown;if(shown)shown.disabled=!isShown;const help=root.querySelector('[data-fr-shown-help]');if(help)help.hidden=!isShown;validate();}
 modeInputs.forEach(input=>input.addEventListener('change',setMode));
 const file=root.querySelector('[data-fr-artwork]');const design=root.querySelector('[data-fr-design]');const notes=root.querySelector('[data-fr-wording]');
 function validate(){if(fields.disabled){file.required=false;notes.required=false;file.setCustomValidity('');return;}file.required=design.value==='Upload my artwork reference';notes.required=design.value==='Personalize the wording';file.setCustomValidity(file.files[0]?.size>20*1024*1024?root.dataset.fileLimit:'');}
 form.addEventListener('change',validate);
 setMode();
 if(!select){form.addEventListener('submit',event=>{validate();if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}},true);return;}
 let submitting=false;
 async function submitOrder(local){
  if(submitting)return;
  validate();
  if(!form.reportValidity())return;
  if(local&&!root.dataset.localVariant)return;
  submitting=true;
  const buttons=[...form.querySelectorAll('button[type=submit], [data-fr-local-order]')];
  const prior=buttons.map(button=>button.disabled);
  buttons.forEach(button=>button.disabled=true);
  const error=root.querySelector('[data-catalog-error]');error.hidden=true;
  try{
   const data=new FormData(form);
   if(local){data.set('id',root.dataset.localVariant);data.set('properties[Fulfillment]','Local pickup or local delivery');}
   const response=await fetch(form.action.replace(/\/cart\/add.*$/,'/cart/add.js'),{method:'POST',body:data,headers:{Accept:'application/json'}});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||result.message||root.dataset.cartError);
   window.location.assign(root.dataset.cartUrl);
  }catch(e){error.textContent=e.message;error.hidden=false;buttons.forEach((button,index)=>button.disabled=prior[index]);submitting=false;}
 }
 root.querySelector('[data-fr-local-order]')?.addEventListener('click',()=>submitOrder(true));
 if(root.dataset.localVariant){
  document.addEventListener('click',event=>{
   const link=event.target.closest('a[href]');
   if(!link)return;
   const url=new URL(link.href,window.location.href);
   if(url.origin!==window.location.origin||url.pathname!=='/products/custom-leather-patch-hat-local-pickup-only')return;
   event.preventDefault();event.stopImmediatePropagation();submitOrder(true);
  },true);
 }
 form.addEventListener('submit',event=>{event.preventDefault();event.stopImmediatePropagation();submitOrder(false);},true);
}
document.querySelectorAll('.fr-customizer').forEach(initializeFlatRiverOrder);
new MutationObserver(records=>{records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType!==1)return;if(node.matches('.fr-customizer'))initializeFlatRiverOrder(node);node.querySelectorAll('.fr-customizer').forEach(initializeFlatRiverOrder);}));}).observe(document.body,{childList:true,subtree:true});
  } catch(e) { console.error(e); }
})();

})();
